import React from 'react'

import {
  FieldSpec,
  LinkedPathField,
  PaginatedTable,
  RelatedLinkedField,
  RelatedListValueField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key: string]: FieldSpec } = {
  pallet: {
    id: 'pallet',
    label: 'Pallet',
    ordering: 'container__xid',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  client: {
    id: 'pallet.client.name',
    label: 'Client',
    ordering: 'container__pallet__account__name',
    renderer: ValueField,
  },
  clientID: {
    id: 'pallet.clientID',
    label: 'Client ID',
    ordering: 'container__pallet__client_uid',
    renderer: ValueField,
  },
  skus: { id: 'pallet.skus', label: 'SKUs', renderer: RelatedListValueField('sku') },
  path: {
    id: 'pallet.objPath',
    label: 'Path',
    ordering: 'container__place__search_path',
    renderer: LinkedPathField,
  },
}

export const FreightOrderPalletListTable = (props: ListTableProps) => {
  const { paginator, fields, title = 'Ordered Pallets' } = props

  return (
    <>
      <PaginatedTable
        title={title}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
      />
    </>
  )
}
